import React, { useEffect } from 'react';
import pollForBulkUploads, { MAX_POLL_DURATION_MS } from '../../utils/pollForBulkUploads';
import { BulkUploadDetailsSchemaContract } from 'schemas/BulkUploadDetailsSchema';
import { PollingAction } from 'types';

const DEFAULT_POLL_INTERVAL_MS = 3500;
const DEFAULT_MAX_TRIES = Math.ceil(MAX_POLL_DURATION_MS / DEFAULT_POLL_INTERVAL_MS);

const BulkUploadsPolling = ({ id,
    action,
    tries = DEFAULT_MAX_TRIES,
    interval = DEFAULT_POLL_INTERVAL_MS,
    setBulkUploadRecordData,
    onSuccess,
    onFailure,
    onTimeout,
}:
    {
    id: string | null;
    action: PollingAction;
    tries? : number;
    interval? : number;
    setBulkUploadRecordData: (bulkUploadRecord : BulkUploadDetailsSchemaContract[0] | null) => void;
    onSuccess?:() => void;
    onFailure?:() => void;
    onTimeout?:(data: BulkUploadDetailsSchemaContract[0] | null) => void;
}) => {

  useEffect(() => {
    if (id) {
      const poll = pollForBulkUploads(parseInt(id),action,tries,interval,setBulkUploadRecordData ,onSuccess, onFailure, onTimeout);
      return () => {
        poll.stop();
      };
    }
  }, [id]);

  return null;
};

export default BulkUploadsPolling;
